<script>
  export let name
  export let value
  export let label
  export let placeholder = ''
  export let required = false
  export let error = ''
</script>

<style>
  .field {
    width: 100%;
    margin-top: 20px;
  }

  .field .label {
    color: #090a0b;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 16px;
  }

  .field .label span {
    color:  #d83b41;
  }

  .field .input {
    font-size: 16px;
    line-height: 22px;
    color: #515151;
    border: 1px solid #b1b5b9;
    border-radius: 4px;
    height: 48px;
    box-sizing: border-box;
    padding: 13px 16px;
    width: 100%;
  }

  .field.error .input {
    border-color: #d83b41;
  }

  .field .error {
    font-size: 11px;
    line-height: 15px;
    margin-top: 4px;
    color: #d83b41;
  }
</style>

<div class="field" class:error={!!error}>
  <label class="label" for={name}>
    {label}
    {#if required}
      <span>*</span>
    {/if}
  </label>
  <input id={name} class="input" {value} {name} {placeholder} />
  {#if !!error}
    <div class="error" role="alert">{error}</div>
  {/if}
</div>